module.exports = __webpack_public_path__ + "static/media/stylist-find.a114f0d2.png";